/* app/js/src/components/calendar/expandable/calendar-expandable-picker/calendar-expandable-picker.component.scss */
.picker {
  width: 81px;
  height: 24.4px;
  background-color: rgba(226, 232, 241, 0);
  border: 1px solid #2dbbfc;
  border-radius: 3px;
  color: #2dbbfc;
  cursor: pointer;
  font-size: 12px;
  padding-left: 4px;
}
/*# sourceMappingURL=calendar-expandable-picker.component.css.map */
